module.exports = __webpack_public_path__ + "front/img/edm-intro.ecfd0de6.png";